import React, { Component } from 'react';
import {
	ICustomTooltipProps,
	ICustomTooltipState,
	ITemplate,
} from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import Header from './styledComponents/Header';
import Item from './styledComponents/Item';
import { utils, helpers } from '@kurtosys/ksys-app-template';
import { TranslationContext } from '@kurtosys/ksys-app-components/dist/components/base/Translate/Translate';
import { ITranslationContextValue } from '@kurtosys/ksys-app-components/dist/components/base/Translate/models';
import { IFormatter } from '../../models/commonTypes';

const formatter = utils.formatter.formatter;

@inject('appStore', 'customTooltipStore')
@observer
export class CustomTooltip extends Component<ICustomTooltipProps, ICustomTooltipState> {
	static configurationKey: 'customTooltip' = 'customTooltip';
	static styleKey: 'customTooltip' = 'customTooltip';
	constructor(props: ICustomTooltipProps) {
		super(props);
	}

	getTemplateValue(template: ITemplate, payload: any): string {
		const { conditions = [] } = template;
		for (const condition of conditions) {
			const conditionalHelper = new helpers.ConditionalHelper(condition.conditional);
			if (conditionalHelper.matches(payload)) {
				return condition.value;
			}
		}
		return template.default;
	}

	getHeaderText(headerTemplate?: ITemplate, payload?: any[]): string | undefined {
		if (headerTemplate && payload) {
			const innerPayload = payload.length > 0 && payload[0].payload;
			if (innerPayload) {
				const headerTemplateText = this.getTemplateValue(headerTemplate, innerPayload);
				return utils.replacePlaceholders({ values: innerPayload, text: headerTemplateText });
			}
		}
	}

	applyFormat(dataKey: 'x' | 'y', value: any, translationContext?: ITranslationContextValue) {
		const formatterConfiguration = this.props && this.props.formatters && this.props.formatters[dataKey];
		if (formatterConfiguration) {
			if (!formatterConfiguration.locale) {
				formatterConfiguration.locale = translationContext && translationContext.culture;
			}
			if (!formatterConfiguration.options) {
				formatterConfiguration.options = {};
			}
			return formatter(formatterConfiguration as IFormatter, value);
		}
		return value;
	}

	getItemText(itemTemplate?: ITemplate, payload?: any, translationContext?: ITranslationContextValue): string | undefined {
		if (itemTemplate && payload) {
			const itemTemplateText = this.getTemplateValue(itemTemplate, payload);
			const { dataKey, value } = payload;
			payload.value = this.applyFormat(dataKey, value, translationContext);
			return utils.replacePlaceholders({ values: payload, text: itemTemplateText });
		}
	}

	render() {
		const { className, customTooltipStore, payload, active } = this.props;

		if (!customTooltipStore || !payload || !active) {
			return null;
		}


		return (
			<TranslationContext.Consumer>
				{ (translationContext) => {
					const { itemTemplate, headerTemplate } = customTooltipStore.configuration;
					const headerText: string | undefined = this.getHeaderText(headerTemplate, payload);
					return (
						<Wrapper className={ className }>
							{
								headerText && <Header>{ headerText }</Header>
							}
							{
								payload.map((item: any) => {
									const itemContent = this.getItemText(itemTemplate, item, translationContext);
									return (
										<Item key={ item.name }>{ itemContent }</Item>
									);
								})
							}
						</Wrapper>
					);
				} }
			</TranslationContext.Consumer>
		);
	}
}

export default InjectedStyledComponent(CustomTooltip, 'customTooltip');

